import { Component, OnInit } from "@angular/core";
import { DeviceCheckService } from "src/app/core/survey/shared/services/device-check.service";
import { ColumnTypes } from "src/app/shared/Models/enums/ColumnTypeEnum";
import { EmptyBuilding } from "src/app/shared/Models/read/EmptyBuilding";
import { FilterableTableComponent } from "src/app/shared/table/filterable-table.component";
import { ToastService } from "src/app/shared/toast.service";
import { BuildingService } from "../../services/building.service";
import { first } from "rxjs/operators";
import { LoaderService } from "src/app/shared/services/loader.service";

@Component({
  selector: "app-empty-building-list",
  templateUrl: "./empty-building-list.component.html",
  styleUrls: ["./empty-building-list.component.scss"],
})
export class EmptyBuildingListComponent
  extends FilterableTableComponent<EmptyBuilding>
  implements OnInit
{
  allCols: any[] = [
    {
      field: "lomKey",
      header: "BUID/INTERNAL ID",
      visibleOnPortrait: true,
      hasFilter: true,
      type: ColumnTypes.STRING,
      transform: (data: EmptyBuilding) =>
        data.lomKey == null ? data.id : data.lomKey.toString(),
      template: "default",
      filterSearch: true,
      hasEmptyValue: true,
    },
    {
      field: "area.city",
      header: "CITY",
      visibleOnPortrait: true,
      hasFilter: true,
      type: ColumnTypes.STRING,
      template: "default",
      filterSearch: false,
      hasEmptyValue: true,
    },
    {
      field: "area.fiberHood",
      header: "FIBERHOOD",
      visibleOnPortrait: true,
      hasFilter: true,
      type: ColumnTypes.STRING,
      template: "default",
      filterSearch: false,
      hasEmptyValue: true,
    },
    {
      field: "area.block",
      header: "BLOCK",
      visibleOnPortrait: true,
      hasFilter: true,
      type: ColumnTypes.STRING,
      template: "default",
      filterSearch: false,
      hasEmptyValue: true,
    },
    {
      field: "locked",
      header: "BLOCKED",
      visibleOnPortrait: true,
      hasFilter: true,
      type: ColumnTypes.BOOLEAN,
      template: "default",
      filterSearch: false,
      hasEmptyValue: true,
    },
    {
      field: "lockedAddresses",
      header: "BLOCKED ADDRESSES",
      visibleOnPortrait: true,
      hasFilter: true,
      type: ColumnTypes.STRING,
      transform: (data: EmptyBuilding) => data.lockedAddresses.join(", "),
      template: "default",
      filterSearch: true,
      hasEmptyValue: true,
    },
  ];

  constructor(
    toastService: ToastService,
    deviceCheckService: DeviceCheckService,
    private buildingService: BuildingService,
    private loaderService: LoaderService
  ) {
    super(toastService, deviceCheckService);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.loadData();
  }

  loadData(): void {
    this.buildingService
      .getEmptyBuildings()
      .pipe(first())
      .subscribe(
        (res) => {
          this.tableValues = res;
          this.loaderService.hide();
        },
        (error) => this.loaderService.hide()
      );
  }

  loadTestData(): void {
    this.tableValues = [
      {
        id: "93",
        locked: true,
        lomKey: null,
        lockedAddresses: ["123", "740"],
        area: {
          city: "Ghent",
          fiberHood: "FH00",
          block: "0000",
          areaName: "Ghent FH00",
          handoverMode: false,
          id: "32",
        },
      },
    ];
  }
}
